import { api } from "../services/axios";


const DeleteMassiveProductInvoicingAPI = async (serviceId: string, invoiceType: number, isNotLinked: boolean, productId?: string) => {
    try {
        var result = await api.delete(`/invoicing/DeleteMassive/serviceId=${serviceId}&invoiceType=${invoiceType}&isNotLinked=${isNotLinked}&productId=${productId ?? "\"\""}`);
        var response = result.data;

        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    DeleteMassiveProductInvoicingAPI
}
